/***************************************************************************/
"use client";
/***************************************************************************/

import { VariantProps, cva } from "class-variance-authority";
import * as React from "react";
import { cn } from "../../../utils/css";

const resultVariants = cva(
  "flex flex-col items-center justify-center text-center",
  {
    variants: {
      variant: {
        default: "",
        success: "",
        info: "",
        warning: "",
        error: "",
      },
      size: {
        default: "gap-2",
        sm: "gap-1",
        lg: "gap-3",
      },
    },
    defaultVariants: {
      size: "default",
    },
  },
);

const ResultContext = React.createContext<{
  variant?:
    | "default"
    | "success"
    | "info"
    | "warning"
    | "error"
    | undefined
    | null;
  size?: "default" | "sm" | "lg" | undefined | null;
}>({ variant: "default", size: "default" });

const Result: React.FC<
  React.HTMLAttributes<HTMLDivElement> & VariantProps<typeof resultVariants>
> = ({ className, variant, size, ...props }) => {
  return (
    <ResultContext.Provider value={{ variant, size }}>
      <div className={cn(resultVariants({ size }), className)} {...props} />
    </ResultContext.Provider>
  );
};

export { Result, ResultContext, resultVariants };
